import { Component, Input } from '@angular/core';
import { DefaultLayoutAlignDirective, DefaultLayoutDirective } from 'ng-flex-layout';
import { IconComponent } from '../icon/icon.component';
import { NgClass, NgIf, NgStyle, NgTemplateOutlet } from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
  standalone: true,
  selector: 'app-new-tile-button',
  templateUrl: './new-tile-button.component.html',
  styleUrls: ['./new-tile-button.component.scss'],
  imports: [
    DefaultLayoutDirective,
    DefaultLayoutAlignDirective,
    IconComponent,
    NgClass,
    MatProgressSpinner,
    NgTemplateOutlet,
    NgIf,
    NgStyle,
  ],
})
export class NewTileButtonComponent {
  @Input() public loading: boolean;
  @Input() public disabled: boolean;
  @Input() public icon: string;
  @Input() public iconSize: number;
  @Input() public title: string;
  @Input() public subtitle: string;
  @Input() public onClickFn: () => void;
  @Input() bgColor!: string;
  @Input() bgHoverColor: string;
  @Input() height: string;

  public hovered = false;

  constructor() {
  }

  public onClick() {
    if (!this.disabled) {
      this.onClickFn();
    }
  }

  get currentBgColor(): string {
    return this.hovered && (this.bgHoverColor !== undefined) ? this.bgHoverColor : this.bgColor ?? '';
  }

  get shoudAddFilter() {
    return (this.bgHoverColor === undefined) && this.hovered;
  }
}
